'use strict';

var ModalManager = require('../ModalManager');
var Form = require('../../AjaxAPI/Form');

var ModalWizardPage = function (form) {
    this.initialize(form);
};
ModalWizardPage.prototype = {
    wizard: null,
    ajaxForm: null,

    /*
        Public Methods
    */

    /**
     * @param formID The ID of the form element.
     */
    initialize: function(formID) {
        this.ajaxForm = new Form(formID);
        this.wizard = ModalManager.getCurrentModalWizard();

        this.ajaxForm.setContentContainer(this.wizard.getModal().getContentContainer());
        this.ajaxForm.setEvaluateJavascript(true);
        this.ajaxForm.addSubmitEvent(this.wizard.getModal().showLoading.bind(this.wizard.getModal()));
        this.ajaxForm.addCompleteEvent(this.wizard.getModal().hideLoading.bind(this.wizard.getModal()));
        this.ajaxForm.addCompleteEvent(this._cleanup.bind(this));
        this.ajaxForm.addValidationFailureEvent(this.wizard.getModal().hideLoading.bind(this.wizard.getModal()));
    },

    _cleanup: function() {
        delete(this.wizard);
        delete(this.ajaxForm);
    }

};

module.exports = ModalWizardPage;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/Modal/ModalWizardPage.js
// module id = 35
// module chunks = 0